// Functional component for the card displaying detailed information about a selected restaurant

import { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../App";
import { Restaurant } from "../models/RestaurantInfo";
import LengthBadge from "./LengthBadge";

interface RestaurantCardProps {
    restaurant: Restaurant;
}

export const RestaurantCard = (props: RestaurantCardProps) => {
    const { theme } = useContext(ThemeContext);
    const [graphType, setGraphType] = useState<string>("Prediction");

    // Grab and format open times into divs
    const openTimes = props.restaurant.openingHours.split(", ").map((str) => {
        const weekDay: string = str.split(" ")[0]
        const openTime: string = str.split(" ")[1]

        return (
            <div className="open-times--container">
                <div className="open-time">
                    <p>{weekDay}</p>
                </div>

                <div className="open-time">
                    <p>{openTime}</p>
                </div>
            </div>
        )
    })

    // Getting the selected graph (plain image)
    //let predictionImageSrc = `https://qtms-web-api.azurewebsites.net/api/restaurant/get-graph/${props.restaurant.restaurantName}/${graphType}/${theme}`;
    let predictionImageSrc = process.env.PUBLIC_URL + `/images/${props.restaurant.restaurantName.toLowerCase()}-${graphType.toLowerCase()}-${theme.toLowerCase()}.png`;

    useEffect(() => {
        //predictionImageSrc = `https://qtms-web-api.azurewebsites.net/api/restaurant/get-graph/${props.restaurant.restaurantName}/${graphType}/${theme}`;
        predictionImageSrc = process.env.PUBLIC_URL + `/images/${props.restaurant.restaurantName.toLowerCase()}-${graphType.toLowerCase()}-${theme.toLowerCase()}.png`;
    }, [graphType])
    
    return (
        <div className="rc" id={theme}>

            {/*Title*/}
            <div className="rc-content">
                <div>
                    <a href={props.restaurant?.website}>
                        <h2 className="rc-title" id={theme}>{props.restaurant.restaurantName}</h2>
                    </a>
                </div>
                
                <div className="rc-item-right">
                    <h2 className="rc-queue-length">
                        {props.restaurant.queueLength} 
                    </h2>

                    <LengthBadge
                        queueLabel={props.restaurant.queueLabel ?? "-"}
                        largeBadge={true}
                    />
                </div>
            </div>

            <hr className="rc-separator"/>

            {/*Information*/}
            <div className="rc-content">
                <p>{props.restaurant?.address}</p>
                <br/>
                {openTimes}
            </div>

            <hr className="rc-separator"/>
            
            {/*Graph*/}
            <div className="rc-content">
                <label className="content-label">Graph content</label>

                <select value={graphType} onChange= {(value) => setGraphType(value.target.value)}>
                    <option value= "prediction">Prediction</option>
                    <option value= "30-day-average">30-day average</option>
                    <option value= "yesterday-average">Yesterday's average</option>
                </select>

                <img className="graph" src={predictionImageSrc}/>
            </div>
        </div>
    )
};

export default RestaurantCard;
